import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MapPin } from "lucide-react";
import { NeuCard } from "../../components/neu/Neu";
import { fetchDutyReport } from "../../api/dutyReport";
import { DutyReportHeader } from "./DutyReportHeader";
import { formatTime } from "../../lib/format";

const HEADS = ["reports.employee", "duty.title", "reports.date", "reports.checkIn", "reports.checkOut", "check.worked", "reports.dutyDistance"];

// من حضر في موقع الواجب الميداني ومتى — يتبع فلاتر صفحة التقارير.
export const DutyReport = ({ filters }) => {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchDutyReport(filters).then(setData).catch(() => setData(null));
  }, [filters]);

  if (!data) return null;

  return (
    <NeuCard data-testid="duty-report">
      <DutyReportHeader filters={filters} />

      <div className="mt-4 flex flex-wrap gap-2" data-testid="duty-report-totals">
        {[
          ["reports.dutyCheckIns", data.totals.check_ins],
          ["reports.dutyCount", data.totals.duties],
          ["dashboard.employees", data.totals.employees],
          ["reports.hours", data.totals.worked_hours],
        ].map(([key, value]) => (
          <span key={key} className="rounded-full bg-primary/10 px-3 py-1 text-xs font-bold text-primary">
            {t(key)}: {value}
          </span>
        ))}
      </div>

      {!data.rows.length ? (
        <p className="mt-4 text-sm text-muted-foreground" data-testid="duty-report-empty">
          {t("reports.dutiesEmpty")}
        </p>
      ) : (
        <div className="mt-4 overflow-x-auto">
          <table className="w-full min-w-[820px] text-start text-sm" data-testid="duty-report-table">
            <thead>
              <tr className="border-b border-border/60">
                {HEADS.map((c) => (
                  <th key={c} className="px-3 py-3 text-start text-[11px] tracking-normal text-muted-foreground">
                    {t(c)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.rows.map((r) => (
                <tr key={r.id} data-testid={`duty-report-row-${r.id}`} className="border-b border-border/30">
                  <td className="px-3 py-3 font-semibold">{r.employee_name || "—"}</td>
                  <td className="px-3 py-3">
                    <p className="font-bold">{r.duty_title || "—"}</p>
                    {r.duty_address ? (
                      <p className="flex items-center gap-1 text-[11px] text-muted-foreground">
                        <MapPin className="h-3 w-3" /> {r.duty_address}
                      </p>
                    ) : null}
                  </td>
                  <td className="px-3 py-3 font-mono">{r.date}</td>
                  <td className="px-3 py-3 font-mono">{formatTime(r.check_in_at)}</td>
                  <td className="px-3 py-3 font-mono">{formatTime(r.check_out_at)}</td>
                  <td className="px-3 py-3 font-mono">{(r.worked_minutes / 60).toFixed(1)}</td>
                  <td className="px-3 py-3 font-mono text-primary">
                    {r.distance_m != null ? `${Math.round(r.distance_m)} m` : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </NeuCard>
  );
};
